interface SponsorInfo {
  sponsorCode?: string;
  sponsorName?: string;
}

export default class SponsorService {
  private static readonly STORAGE_KEY = 'real_sponsor_info';

  static saveSponsorInfo(info: SponsorInfo): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(info));
    } catch (e) {
      console.error('Error saving sponsor info to localStorage:', e);
    }
  }

  static getSponsorInfo(): SponsorInfo | null {
    try {
      const storedInfo = localStorage.getItem(this.STORAGE_KEY);
      return storedInfo ? JSON.parse(storedInfo) : null;
    } catch (e) {
      console.error('Error retrieving sponsor info from localStorage:', e);
      return null;
    }
  }

  static clearSponsorInfo(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (e) {
      console.error('Error clearing sponsor info from localStorage:', e);
    }
  }
}
